import * as types from "./types";

export function getFullAddress(store: types.Store) {
  return `${store.address.address_line1}, ${store.address.city}, ${store.address.state} ${store.address.zipcode}`;
}
